import { useState } from 'react';
import { ButtonStats, SortField, SortDirection } from '../types';

/**
 * Custom hook for sorting button statistics
 */
export function useSortedStats(stats: ButtonStats[]) {
  const [sortField, setSortField] = useState<SortField>('totalClicks');
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc');

  const handleSort = (field: SortField) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      // Default to ascending for name, descending for numerical fields
      const defaultDirection = field === 'name' ? 'asc' : 'desc';
      setSortDirection(defaultDirection);
    }
  };

  const getSortedStats = () => {
    return [...stats].sort((a, b) => {
      let comparison = 0;
      
      switch (sortField) {
        case 'name':
          comparison = a.name.localeCompare(b.name);
          break;
        case 'totalClicks':
          comparison = a.totalClicks - b.totalClicks;
          break;
        case 'lastClick': {
          const dateA = a.lastClick ? new Date(a.lastClick).getTime() : 0;
          const dateB = b.lastClick ? new Date(b.lastClick).getTime() : 0;
          comparison = dateA - dateB;
          break;
        }
        case 'clicksLastHour':
          comparison = a.clicksLastHour - b.clicksLastHour;
          break;
        case 'clicksLast24h':
          comparison = a.clicksLast24h - b.clicksLast24h;
          break;
        case 'clicksLast7d':
          comparison = a.clicksLast7d - b.clicksLast7d;
          break;
        case 'averageClicksPerDay':
          comparison = parseFloat(a.averageClicksPerDay) - parseFloat(b.averageClicksPerDay);
          break;
      }

      return sortDirection === 'asc' ? comparison : -comparison;
    });
  };

  return {
    sortField,
    sortDirection,
    handleSort,
    getSortedStats
  };
} 